import { useState } from "react";
import PageTemplate from "../components/PageTemplate";
import PhotoAlbum from "react-photo-album";
import "react-photo-album/rows.css";
import "react-photo-album/columns.css";
import "react-photo-album/masonry.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Fullscreen, Slideshow, Download } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Container from "../components/Container";
import engagementPhotos from '../engagementPhotos.json';
import chinaPhotos from '../chinaPhotos.json';
import vietnamPhotos from '../vietnamPhotos.json'
import engagementThumbnailsPhotos from '../engagementThumbnailsPhotos.json';
import chinaThumbnailsPhotos from '../chinaThumbnailsPhotos.json';
import vietnamThumbnailsPhotos from '../vietnamThumbnailsPhotos.json'
import PageFade from "../motions/PageFade";


const allPhotos = [...engagementPhotos, ...chinaPhotos, ...vietnamPhotos]
const allThumbnails = [...engagementThumbnailsPhotos, ...chinaThumbnailsPhotos, ...vietnamThumbnailsPhotos]

function AllPhotos() {
  const [index, setIndex] = useState(-1);

  return (
    <PageFade>
      <PageTemplate minor={true} title="All Photos" textColor="text-gold">
        <Container>
          <div>
            <PhotoAlbum
              photos={allThumbnails}
              layout="masonry"
              onClick={({ index }) => setIndex(index)}
            />

            <Lightbox
              slideshow={{ delay: 5000 }}
              slides={allPhotos}
              open={index >= 0}
              index={index}
              close={() => setIndex(-1)}
              plugins={[Fullscreen, Slideshow, Download]}
              styles={{
                container: {
                  backgroundColor: "rgba(0, 0, 0, 0.85)"
                },
              }}
            />
          </div>
        </Container>
      </PageTemplate>
    </PageFade>
  );
}

export default AllPhotos;
